import React from "react";
import "@styles/SingleHotelViewcss/Generalinfo.css";

const GeneralInformation: React.FC = () => {
  
  return (
    <div>
      <header className="header">Owner Contact Information:</header>
      <div className="generalInfo">
        <div className="OwnerInfo">
          <div>
            <p className="ownerdata">Name of the Owner</p>
          </div>
          <div>
            <p className="ownername">Ranga Reddy</p>
          </div>
        </div>
        <div>
          <div>
            <p className="ownerdata">Number of Vendors</p>
          </div>
          <div>
            <p className="ownername">0</p>
          </div>
        </div>
        <div>
          <div>
            <p className="ownerdata">Operating Hours</p>
          </div>
          <div>
            <p className="ownername">12 Hrs</p>
          </div>
        </div>
       
      </div>
      <div className="Address-div">

        <p className="ownerdata">Address</p>
        <p className="owneradddetails">3rd Floor, Alcazar Mall, Plot No. 497/498, Road No. 36,  Jubilee Hills, Hyderabad, Telangana - 500033.</p>

      </div>
    </div>
  );
};

export default GeneralInformation;
